import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    headerTitleContainer: {
        justifyContent: "center",
        position: "absolute",
        alignItems: "center",
        zIndex: -1,
        right: 0,
        left: 0
    },
    emptyIconContainer: {
        justifyContent: "center",
        alignItems: "center"
    },
    headerPlaceholder: {
        width: 38
    },
    loadingContainer: {
        justifyContent: "center",
        alignItems: "center",
        flex: 1
    },
    emptyContainer: {
        justifyContent: "center",
        alignItems: "center",
        flex: 1
    },
    markAllButton: {
        flexDirection: "row",
        alignItems: "center"
    },
    listContainer: {
        flex: 1
    },
    headerWrapper: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    footerLoader: {
        justifyContent: "center",
        alignItems: "center"
    },
    headerTitle: {
        textAlign: "center"
    },
    listContent: {
        flexGrow: 1
    },
    backButton: {
        justifyContent: "center",
        alignItems: "center"
    },
    emptyText: {
        textAlign: "center"
    },
    container: {
        flex: 1
    }
});
export default stylesheet;
